import React from "react";
import { Button, Icon } from "semantic-ui-react";
// import "./cmp-session-timeout.css";

export default function CMP_OUTDATED_VERSION({
  set_mdl_open,
  isUserAvailable,
  modalTitle = "Outdated Version",
  modalMessage = "Your version of the application is outdated. Please update to the latest version.",
  onConfirm = () => {},
}) {
  function onClick() {
    onConfirm();
    set_mdl_open(false);
  }
  /* RENDER */
  return (
    <>
      {/* Header */}
      <div className="session-modal-header">
        <div
          style={{
            fontSize: "18px",
            fontWeight: "600",
          }}
        >
          {modalTitle}
        </div>
      </div>

      {/* Content */}
      <div className="session-modal-content">
        <img
          src="/outdated.svg"
          alt="Session Expired"
          style={{
            width: "80px",
            height: "80px",
            marginBottom: "12px",
          }}
        />
        <p className="confirmation_message">{modalMessage}</p>
      </div>

      {/* Footer */}
      <div className="modal-footer" style={{ justifyContent: "center" }}>
        <Button type="button" color="red" onClick={onClick}>
          <Icon name="superpowers" />
          {isUserAvailable ? "Reload & Login" : "Reload"}
        </Button>
      </div>
    </>
  );
}
